/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbs_sku = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_sku" | "PdpSharedBlurbLeadTime_sku">;
    readonly " $refType": "PdpRespSidebarBlurbs_sku";
};
export type PdpRespSidebarBlurbs_sku$data = PdpRespSidebarBlurbs_sku;
export type PdpRespSidebarBlurbs_sku$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_sku$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_sku">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_sku",
  "selections": [
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbShipping_sku"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};
(node as any).hash = 'aeda1ba65f61ba908259f90b4984ebe3';
export default node;
